import Component from "vue-class-component";
import $ from "jquery";
import { ServicesFactoryInstance } from "../../Controls/ServicesFactory";
import { DemandeEditionTableauDto } from "../../../dto/GenApi.iNotPaie.Dto/DemandeEditionTableauDto";
import { LigneDeclarationChargesDto } from "../../../dto/GenApi.iNotPaie.Dto/LigneDeclarationChargesDto";
import { VueBase } from "../../Controls/VueBase";
import { NotificationServiceInstance } from "../../../shared/services/notification.service";

interface cumulLigneDeclarationCharges {
	NoLigne?: number;
	Titre?: string;
	NbSalarie: number;
	Base: number;
	TauxSalariale?: number;
	TauxPatronal?: number;
	Cotisation: number;
}

@Component
export default class ModalDeclarationCharges extends VueBase {
	public ligneDeclarationCharges: LigneDeclarationChargesDto[] = [];
	public tableau?: DemandeEditionTableauDto = undefined;
	public cumulLigneDeclarationCharges: cumulLigneDeclarationCharges[] = [];
	public titre = "";
	public exportExcel = false;
	public dataReady = false;
	public total = 0;

	public Init(tableau: DemandeEditionTableauDto): void {
    	this.tableau = tableau;
    	this.exportExcel = tableau.exportExcel ?? false;
    	this.titre = tableau.libelleEdition as string;
    	this.cumulLigneDeclarationCharges = [];
    	this.ligneDeclarationCharges = [];
    	this.dataReady = false;
    	this.total = 0;

    	ServicesFactoryInstance.EditionsService.getDeclarationCharges(tableau, (data) => {
    		this.ligneDeclarationCharges = data;
    		this.cumulLigneDeclarationCharges = [];
    		this.dataReady = true;
    		this.total = 0;

    		for (let i = 0; i < this.ligneDeclarationCharges.length; i++) {
    			const ligne = this.ligneDeclarationCharges[i];

    			let ligneCumul = this.cumulLigneDeclarationCharges.filter(c => c.NoLigne == ligne.NoLigne &&
                    c.Titre == ligne.LibelleLigne &&
                    c.TauxSalariale == ligne.TauxSalariale &&
                    c.TauxPatronal == ligne.TauxPatronale)[0];
    			if (ligneCumul == undefined) {
    				ligneCumul = {
    					NbSalarie: 1,
    					Base: (ligne.BasePatronale != undefined && ligne.BasePatronale != 0 ? ligne.BasePatronale : ligne.BaseSalariale) as number,
    					Cotisation: ligne.Cotisation as number,
    					NoLigne: ligne.NoLigne,
    					TauxPatronal: ligne.TauxPatronale,
    					TauxSalariale: ligne.TauxSalariale,
    					Titre: ligne.LibelleLigne
    				};
    				this.cumulLigneDeclarationCharges.push(ligneCumul);
    			} else {
    				ligneCumul.NbSalarie++;
    				ligneCumul.Cotisation += ligne.Cotisation as number;
    				ligneCumul.Base += (ligne.BasePatronale != undefined && ligne.BasePatronale != 0 ? ligne.BasePatronale : ligne.BaseSalariale) as number;
    			}

    			this.total += ligne.Cotisation;
    		}
		});
	}

	public annuler(): void {
    	$("#modalDeclarationCharges").modal("hide");
	}

	public LancerEdition(): void {
    	$("#modalDeclarationCharges").modal("hide");
    	if (this.tableau == undefined) {
			return;
		}
    	NotificationServiceInstance.SendSuccess("La demande d'édition a été prise en compte. Le document sera bientôt disponible");

    	this.tableau.exportExcel = this.exportExcel;
    	ServicesFactoryInstance.EditionsService.getEditionTableau(this.tableau, (r: Blob) => {
			if (this.tableau == undefined) {
				return;
			}

    		if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    			window.navigator.msSaveOrOpenBlob(r, this.tableau.libelleEdition);
    		} else {
				const link = document.createElement("a");
    			document.body.appendChild(link);

    			link.href = window.URL.createObjectURL(r);
    			link.download = this.tableau.libelleEdition + (this.exportExcel ? ".xlsx" : ".pdf");
    			link.click();

    			NotificationServiceInstance.SendSuccess("L'édition de la liste '" + this.tableau.libelleEdition + "' s'est correctement déroulée !");
    		}
    	});
	}
}




// WEBPACK FOOTER //
// ./src/components/tableaux/modalDeclarationCharges/modalDeclarationCharges.ts